import React, { useEffect } from 'react';
import {
	Button,
	Modal,
	ModalHeader,
	ModalBody,
	Spinner,
} from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { deleteInstallationLocation } from '../../../../../slices/thunks';
import { setRequireCloseModal } from '../../../../../slices/installationLocation/reducer';
import { Icons } from '../../../../../utils/Icons';

const DeleteInstallationLocationModal = ({ dataInstallationLocation, isOpen, handlerToggleModal, toggleRefetch }) => {
	const dispatch = useDispatch();

	const selectorInstallationLocation = createSelector(
		state => state.InstallationLocation,
		data => ({
			isDeleting: data.isDeleting,
			isDeleted: data.isDeleted,
			isDeleteError: data.isDeleteError,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);

	const { isDeleting, requireCloseModal } = useSelector(selectorInstallationLocation);

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	function handlerDelete() {
		dispatch(deleteInstallationLocation(dataInstallationLocation));
	}

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h3 className='mb-3'>
							¡Estás a punto de eliminar una ubicación para instalación!
						</h3>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
						<p className='small'>
							Ubicación Para Instalación: {dataInstallationLocation !== null ? dataInstallationLocation.name : ''}
						</p>
						<div className='hstack gap-2 justify-content-center'>
							<Button
								color='light'
								onClick={() => {
									handlerToggleModal();
								}}
							>
								Cancelar
							</Button>
							<button
								className='btn btn-danger'
								onClick={() => handlerDelete()}
								disabled={isDeleting}
							>
								{isDeleting ? (
									<Spinner size='sm' />
								) : (
									<>
										<i className='ri-delete-bin-line me-1'></i>
										Eliminar
									</>
								)}
							</button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</div>
	);
};

export default DeleteInstallationLocationModal;
